// extracted by mini-css-extract-plugin
export default {"SendNotesView":"PK9G9qa7hs5g9bcoEetz","errorMessageContainer":"gY95Kiry_6Pva4FWMR62","footer":"NVjH59CG79rWQILysYrc"};